import cookies from 'js-cookie'
import events from '@/core/events'
import socket from '@/core/socket'
import cache from '@/core/cache'
import rest from '@/core/rest'
import modal from '@/core/modal'
import moment from 'moment'
import hashTracker from '@/core/hashTracker'
import ServerCache from '@/plugins/ServerCache'
import alert from '@/core/alert'
import GlobalData from '@/../../api/app/Shared/GlobalData'

const cookieOptions = {
  secure: true,
  sameSite: 'none'
}

// We don't need this cookie options in localhost. Otherwise our file download
// system won't work in the localhost.
if (window.location.hostname === 'localhost') {
  delete cookieOptions.secure
  delete cookieOptions.sameSite
}

export default {

  loggedIn: false,
  sideMenuCode: null,
  token: null,
  user: null,
  isReady: false,
  password_expired: false,
  callbacks: [],

  whenReady (callback) {
    if (this.isReady === false) {
      this.callbacks.push(callback)
      return
    }

    callback()
  },

  whenReadyPromise () {
    return new Promise((resolve) => {
      this.whenReady(resolve)
    })
  },

  callCallbacks () {
    for (const index in this.callbacks) {
      this.callbacks[index]()
    }
    this.callbacks = []
  },

  init () {
    if (cookies.get('indication', cookieOptions)) {
      this.loggedIn = true
      this.token = cookies.get('indication', cookieOptions)
      this.user = JSON.parse(cookies.get('data', cookieOptions))
      // First, we should check the token is expired or not.
      this.refreshUser(() => {
        this.callCallbacks()
        socket.init()
        ServerCache.init()
      })
    }
  },

  initToken (token, cb = () => {}) {
    this.loggedIn = true
    this.token = token.replace(/ /g, '+')
    // First, we should check the token is expired or not.
    this.refreshUserByToken(() => {
      this.callCallbacks()
      socket.init()
      ServerCache.init()
      cb()
    })
  },

  refreshUserByToken (callback) {
    if (this.token && this.token.length > 0) {
      rest.get('auth/refreshByToken', { token: this.token }, (response) => {
        cookies.set('indication', this.token, Object.assign(
          {}, cookieOptions, { expires: response.data.stay_logged_in_hours / 24 }))

        this.refresh(response.data)
        // if (!this.password_expired) {
        //   window.router.push({ name: 'renew' })
        // } else {
        window.router.push({ name: 'home' })
        // }
        if (typeof callback === 'function') {
          callback()
        }
      })
    }
  },

  refreshUser (callback) {
    const data = {}
    if (window.location.href.includes('zendesk=login')) {
      data.isZendesk = true
    } else if (window.location.href.includes('zendesk=logout')) {
      window.location.search = ''
    }
    if (this.token && this.token.length > 0) {
      rest.get('auth/refresh', data, (response) => {
        if (response.redirect) {
          window.location.href = response.redirect
          return
        }
        this.refresh(response.data)
        // if (!this.password_expired) {
        //   window.router.push({ name: 'renew' })
        // }
        if (typeof callback === 'function') {
          callback()
        }
      })
    }
  },

  isTeamBackoffice (team_id) {
    return this.user && this.user.permittedOwners.some(o => o.id === team_id && o.is_team)
  },

  isAdmin () {
    if (!this.user) {
      return false
    }
    return this.hasRole('administrator') ||
      this.user.email.toLowerCase() === 'info@bauexperts.de' || // TODO: comment out - is not an admin
      this.user.email.toLowerCase() === 'admin@bauexperts.de'
  },

  isCustomer () {
    return this.hasRole('customer')
  },

  shouldBeAtLeast (roles) {
    if (this.user === null) {
      return false
    }
    return this.user.roles.some((role) => {
      return roles.indexOf(role) > -1
    })
  },

  getCoworkers () {
    const coworkers = []
    if (!this.user) {
      return []
    }
    this.user.permittedOwners.forEach(team => {
      team.workers.forEach(worker => {
        if (coworkers.some(item => item.id === worker.id) === false) {
          coworkers.push(worker)
        }
      })
    })
    coworkers.sort((a, b) => a.name.localeCompare(b.name))
    return JSON.clone(coworkers)
  },

  hasAnyPermittedUser () {
    if (!this.user) {
      return false
    }
    return this.user.permittedOwners.length > 1
  },

  hasRole (role) {
    if (this.user === null) {
      return false
    }
    return this.user.roles.indexOf(role) > -1
  },

  getToken () {
    return this.token
  },

  getUser () {
    return JSON.clone(this.user)
  },

  logout () {
    events.fire('auth@onLogout')
    this.isReady = false
    this.loggedIn = false
    this.token = null
    this.user = null
    cookies.remove('indication', cookieOptions)
    cookies.remove('data', cookieOptions)
    socket.close()
    cache.clear()
    hashTracker.clear()
    ServerCache.clear()
  },

  openTermsModal (user) {
    // Users have to accep the terms and conditions
    if (user.isTermsAccepted === 0) {
      // modal.open({
      //   component: () => import('@/views/user/Terms'),
      //   classes: {
      //     dialog: 'modal-700',
      //     content: 'modal-terms'
      //   },
      //   data: {
      //     cantCloseByBackButton: true,
      //     onAccepted: () => {
      //       this.refreshUser()
      //     }
      //   }
      // })
      // modal.open({
      //   component: () => import('@/views/user/Terms'),
      //   classes: {
      //     dialog: 'modal-full-screen',
      //     content: 'modal-wizard'
      //   },
      //   data: {
      //     grandParentBridge: {
      //       onClick: () => {}
      //     },
      //     cantCloseByBackButton: true,
      //     // withOptions: true,
      //     // withActions,
      //     // options: this.offer,
      //     modalType: 'fullscreen'
      //   },
      //   onClose: () => {
      //   }
      // })
    }
  },

  openInvitationWizard (user) {
    // Users have to accep the terms and conditions
    modal.open({
      component: () => import('@/views/user/InvitationWizard'),
      classes: {
        dialog: 'modal-700',
        content: 'modal-terms'
      },
      cantCloseByBackButton: true,
      data: {
        onAccepted: () => {
          this.refreshUser()
        }
      }
    })
  },

  login (data) {
    // this.openTermsModal(data.user)
    this.loggedIn = true
    this.token = data.token
    this.user = data.user
    // if (!this.user.name) {
    //   this.openInvitationWizard()
    // }
    this.password_expired = this.getDateDiff(data.user.password_expire_at)
    cookies.set('indication', this.token, Object.assign({}, cookieOptions, { expires: data.stay_logged_in_hours / 24 }))
    // There is a max size limit of cookie data. We shouldn't record all of data
    // Then the page has been refreshed, we will already get the latest permissions.
    // WE don't need to keep it them.
    cookies.set('data', this.getFormattedData(),
      Object.assign({}, cookieOptions, { expires: data.stay_logged_in_hours / 24 }))
    this.isReady = true
    this.callCallbacks()
    socket.init()
  },

  getFormattedData () {
    delete this.user.selectedWorkspace.workers
    return JSON.stringify({
      id: this.user.id,
      email: this.user.email,
      name: this.user.name,
      surname: this.user.surname,
      title_id: this.user.title_id,
      isConfirmed: this.user.isConfirmed,
      profilePicture: this.user.profilePicture,
      roles: [],
      permissions: [],
      password_expire_at: this.user.password_expire_at,
      is_locked_for_community: this.user.is_locked_for_community,
      socket_address: this.user.socket_address,
      permittedOwners: [],
      selectedWorkspace: this.user.selectedWorkspace
    })
  },

  update (data) {
    this.user.name = data.name
    this.user.surname = data.surname
    this.user.profilePicture = data.avatar ? data.avatar.signed_url : '/images/avatar.png'
    this.user.title = data.title ? data.title.title : ''
    events.fire('auth@refreshed')
    cookies.set('data', JSON.stringify(this.user), cookieOptions)
  },

  refresh (data) {
    // this.openTermsModal(data)
    this.user = data
    // if (!this.user.name) {
    //   this.openInvitationWizard()
    // }
    this.password_expired = true // this.getDateDiff(this.user.password_expire_at)
    this.isReady = true
    cookies.set('data', this.getFormattedData(), cookieOptions)
    events.fire('auth@refreshed')
    socket.whenReady(() => {
      socket.send('request@menuStats', {})
    })
    this.callCallbacks()
  },

  getDateDiff (expire_date) {
    const now = moment([
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    ])

    const expire = moment([
      new Date(expire_date).getFullYear(),
      new Date(expire_date).getMonth(),
      new Date(expire_date).getDate()
    ])

    const dateDiff = expire.diff(now, 'days')
    if (dateDiff > 0) {
      return true
    } else {
      return false
    }
  },

  isPermitted (permission, showAlert = false) {
    if (this.hasPermitted(['EDIT_WORKS']) || permission) {
      return true
    }
    if (showAlert) {
      // alert.info('Sie verfügen nicht über die erforderlichen Berechtigungen, um diese Aktion auszuführen.')
      if (this.user.selectedWorkspace.parent_id === this.user.id) {
        alert.subscribeWarning().then((result) => {
          if (result.isConfirmed) {
            window.router.push({ name: 'subscription' })
          }
        })
      } else {
        alert.subscribeWarningBasic()
      }
    }
    return false
  },

  hasPermitted (permissions) {
    if (!this.user) {
      return false
    }

    if (this.isAdmin()) {
      return true
    }

    return this.user.permissions.some((permission) => {
      return permissions.some(p => p === permission.value)
    })
  },

  isNew () {
    if (!this.user) {
      return false
    }

    return new Date(this.user.selectedWorkspace.created_at) >= GlobalData.stripeUpdateDate
  }

}
